import { render, staticRenderFns } from "./ButtonRemove.vue?vue&type=template&id=5f178d87&scoped=true&"
import script from "./ButtonRemove.vue?vue&type=script&lang=js&"
export * from "./ButtonRemove.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRemove.vue?vue&type=style&index=0&id=5f178d87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f178d87",
  null
  
)

export default component.exports